import { inIframe } from './utils/common';

const isProd =
  process.env.NODE_ENV === 'production' &&
  !location.host.startsWith('localhost');

const env = process.env.VUE_APP_ENV;

const baseUrl = isProd
  ? env == 'eles'
    ? location.origin + '/'
    : location.origin + '/test/'
  : `http://${location.hostname}:5002/`;

const getAdminUiUrl = () => {
  if (env == 'eles') {
    return location.origin + '/';
  } else {
    return location.origin + '/test/';
  }
};

let settings = {
  isProd: isProd,
  baseUrl: baseUrl,
  perPage: 15,
  perPagePaginated: 8,
  referrer: null,
  isIframe: inIframe(),
  adminUrl: getAdminUiUrl(),
};

export default settings;
